const widgets = [...document.querySelectorAll('.weather-widget')];

if (widgets.length) {
  const tz = widgets[0].dataset.tz || 'Europe/Rome';
  const lat = widgets[0].dataset.lat || '45.4642';
  const lon = widgets[0].dataset.lon || '9.19';
  const cacheKey = `weather:${lat},${lon}`;
  const cacheTtl = 600000;
  const fetchTimeout = 5000;

  const clockFormat = new Intl.DateTimeFormat('en-GB', {
    timeZone: tz,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });

  const tickClock = () => {
    const now = clockFormat.format(new Date());
    widgets.forEach((w) => {
      const el = w.querySelector('[data-w-time]');
      if (el) el.textContent = now;
    });
  };
  let clockTimer = null;
  const syncClock = () => {
    if (document.hidden) {
      clearInterval(clockTimer);
      clockTimer = null;
      return;
    }
    tickClock();
    clockTimer ??= setInterval(tickClock, 1000);
  };
  document.addEventListener('visibilitychange', syncClock);
  syncClock();

  const setLabel = (widget, field, index) => {
    const el = widget.querySelector(`[data-w-${field}]`);
    if (el) el.textContent = el.dataset.labels.split('|')[index];
  };

  const moonIndex = () => {
    const synodic = 29.53058867;
    const known = Date.UTC(2000, 0, 6, 18, 14);
    const age = ((Date.now() - known) / 86400000) % synodic;
    if (age < 1.85) return 0;
    if (age < 5.53) return 1;
    if (age < 9.22) return 2;
    if (age < 12.91) return 3;
    if (age < 16.61) return 4;
    if (age < 20.3) return 3;
    if (age < 23.99) return 5;
    if (age < 27.68) return 1;
    return 0;
  };
  const moon = moonIndex();
  widgets.forEach((w) => setLabel(w, 'moon', moon));

  const skyIndex = (code) => {
    if (code === 0) return 0;
    if (code <= 2) return 1;
    if (code === 3) return 2;
    if (code <= 48) return 3;
    if (code <= 67) return 4;
    if (code <= 77) return 5;
    if (code <= 82) return 4;
    return 6;
  };

  const renderWeather = ({ weathercode, temperature }) => {
    const sky = skyIndex(weathercode);
    const temp = Math.round(temperature);
    widgets.forEach((w) => {
      setLabel(w, 'sky', sky);
      setLabel(w, 'weather', sky);
      const tempEl = w.querySelector('[data-w-temp]');
      if (tempEl) tempEl.textContent = tempEl.dataset.format.replace('__n__', temp);
    });
  };

  const hideWeather = () => {
    widgets.forEach((w) => {
      w.querySelectorAll('[data-w-sky], [data-w-weather], [data-w-temp]').forEach((el) => {
        el.hidden = true;
      });
    });
  };

  const cachedWeather = () => {
    try {
      const { at, weather } = JSON.parse(sessionStorage.getItem(cacheKey));
      return Date.now() - at < cacheTtl ? weather : null;
    } catch {
      return null;
    }
  };

  const fetchWeather = async () => {
    const response = await fetch(
      `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lon}&current_weather=true`,
      { signal: AbortSignal.timeout(fetchTimeout) }
    );
    const { current_weather: weather } = response.ok ? await response.json() : {};
    if (!weather) throw new Error('current_weather assente');
    try {
      sessionStorage.setItem(cacheKey, JSON.stringify({ at: Date.now(), weather }));
    } catch {
    }
    return weather;
  };

  const quandoLibero = window.requestIdleCallback ?? ((cb) => setTimeout(cb, 200));
  quandoLibero(async () => {
    try {
      renderWeather(cachedWeather() ?? (await fetchWeather()));
    } catch {
      hideWeather();
    }
  });
}
